import { Field } from '../form/field';

export class Forms {
    customerForm: any;
    cosignerForm: any;
    vehicleForm: any[];
    productForm: Field[];
    lienholderForm: any;
    addlienholderForm: Field[];
    creditInsuranceForm: any;
    lienholder: any;
    creditInsurance: any;
    borrowInfoForm: any;
    coverageInfoForm: any;
    financeForm: any;
    vehicleType: any;

  constructor() {
    this.customerForm = [];
    this.cosignerForm = [];
    this.vehicleForm = [];
    this.productForm = [];
    this.lienholderForm = [];
    this.addlienholderForm = [];
    this.lienholder = {};
    this.creditInsurance = {};
    this.creditInsuranceForm = [];
    this.borrowInfoForm = [];
    this.coverageInfoForm = [];
    this.financeForm = [];
    this.vehicleType = [];
  }
}
